import { useState } from "react";
import "./Terminal.scss";

const cmds = `Say hello to 
multi-line
strings!`;

export default function Terminal() {
  const [termminalValue, settermminalValue] = useState("");

  const [TerminalOutput, setterminalOutput] = useState();

  const addLine = () => {
    switch (termminalValue) {
      case "Anurag":
        {
          setterminalOutput(
            <div className="TerminalOutput">
              <p className="TerminalOutput">ls</p>
              <p className="TerminalOutput">talk</p>
              <p className="TerminalOutput">hacker</p>
              <p className="TerminalOutput">kill</p>
              <p className="TerminalOutput">party</p>
            </div>
          );
        }
        break;
      case "talk":
        setterminalOutput("Opening contact page on port 5000.....");
        break;
      case "hacker":
        {
          setterminalOutput(
            <div>
              <p className="TerminalOutput">
                This is what my girlfriend says I look like. while debugging
              </p>
              <img
                src="assets/programmer-programming.gif"
                alt="meme"
                srcset=""
              />
            </div>
          );
        }
        break;
      case "kill":
        {
          setterminalOutput(
            <div>
              <p className="TerminalOutput">killing ...</p>
              <img src="assets/among-us.gif" alt="meme" srcset="" />
            </div>
          );
        }
        break;
      case "party":
        {
          setterminalOutput(
            <div>
              <img src="assets/dancing-funny-dance.gif" alt="meme" srcset="" />
            </div>
          );
        }
        break;
      default:
        setterminalOutput(`command: "${termminalValue}" not found`);
    }
    settermminalValue("");
  };

  return (
    <div className="terminal">
      <div className="terminal-header">
        <div className="header-buttons">
          <div className="header-btn-close"></div>
          <div className="header-btn-minimise"></div>
          <div className="header-btn-open"></div>
        </div>
      </div>
      <div className="terminal-body">
        <div className="container">
          <p className="terminal-title">Hello I'm Anurag Sharma 🇮🇳 </p>
          <br />
          <p className="terminal-subtitle">Here are some facts about me :</p>
          <br />
          <ul className="terminal-facts">
            <li class="is-rainbow-red">✅ Mobile Developer</li>
            <li class="is-rainbow-orange">✅ Full Stack Developer</li>
            <li class="is-rainbow-yellow">
              ✅ Artificial intelligence Developer
            </li>
            <li class="is-rainbow-green">✅ Software Developer</li>
            <li class="is-rainbow-pink">✅ Student</li>
            <li class="is-rainbow-purpel">
              ✅ A chess enthusiast player with 1200 rating  ♟️
            </li>
            <li>
              <a class="terminal-cmd-info" href="#about">
                {" "}
                Read More..{" "}
              </a>
            </li>
          </ul>
          <br />
          <br />
          <p className="terminal-cmd-info">
            Type "Anurag" into the terminal window and hit run button to see all
            commands
          </p>
          <br />
          <br />
          <div>
            <p className="TerminalOutput">{TerminalOutput}</p>
          </div>
          <div className="terminal-control">
            <div>
              <h1> > </h1>{" "}
            </div>
            <input
              autoCorrect={false}
              value={termminalValue}
              onChange={(event) => settermminalValue(event.target.value)}
              className="cmd-input"
              type="text"
            />
            <button onClick={addLine} className="terminal-run-btn">
              Run
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
